import { onMounted, onUnmounted, ref } from 'vue';

export function useScrollReveal(selector = '.reveal') {
  const elements = ref([]);
  let observer = null;

  onMounted(() => {
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          const nums = entry.target.querySelectorAll('.stat-number, .impact-number');
          nums.forEach(num => {
            const target = parseInt(num.getAttribute('data-target'));
            if (!num.classList.contains('counted')) {
              animateNumber(num, target);
              num.classList.add('counted');
            }
          });
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    elements.value = document.querySelectorAll(selector);
    elements.value.forEach(el => observer.observe(el));
    document.querySelectorAll('.impact-item').forEach(el => observer.observe(el));
  });

  onUnmounted(() => {
    if (observer) observer.disconnect();
  });
}

function animateNumber(el, target) {
  let current = 0;
  const increment = target / 60;
  const timer = setInterval(() => {
    current += increment;
    if (current >= target) {
      el.textContent = target.toLocaleString() + '+';
      clearInterval(timer);
    } else {
      el.textContent = Math.floor(current).toLocaleString();
    }
  }, 25);
}
